<template>
  <div class="booking">
    <div class="booking_header">
      <div class="booking_dates-label">
        {{dispDates}}
      </div>

      <div class="booking_present-label-wrapper" v-if="isPresent">
        <present-sticker imgBlockSize="1.5em" />
      </div>

      <div class="booking_room-label">
        <room-label
          :name="selectedVariant.description"
          :icon="categoryIcons[selectedVariant.id]"
        ></room-label>
      </div>
    </div>

    <div class="booking_body">

      <div
        v-if="bookingStep === 2"
      >
        <v-form ref="guestsForm">
          <guests-list />
        </v-form>
      </div>

      <div
        v-if="bookingStep === 3"
      >
        <options-module
          ref="optionsModule"
        />
      </div>

      <div
        v-if="bookingStep === 4"
      >
        <totals-module></totals-module>

        <div
          class="booking-section booking-section--offer-consent"
          v-if="isKluchi"
        >
          <v-checkbox
            class="ui-checkbox booking_offer-consent-checkbox"
            v-model="offerAccepted"
            :error="offerValidationError"
            hide-details
          >
            <template v-slot:label>
              <span class="booking_offer-consent-text">
                Ознакомлен с <a
                  class="booking_offer-consent-link"
                  href="/o-kurorte/publichnaya-oferta.php"
                  target="_blank"
                  rel="noopener"
                  @click.stop
                >договором публичной оферты</a>
              </span>
            </template>
          </v-checkbox>
        </div>
      </div>

      <div
        v-if="bookingStep === 5"
      >
        <payment-bonuses :disabled="firstBillIsPayed"/>

        <!-- <payment-method-selection class="payment__method-wrap" :disabled="firstBillIsPayed"/> -->

        <div class="booking_certificate-section">
          <span class="booking_certificate-section-title">Использовать сертификат</span>
          <div class="booking_certificate-section-form">
            <certificate-form :firstBillIsPayed="firstBillIsPayed"/>
          </div>
        </div>

        <div class="booking-section" v-if="isPurchaserNotGuest">
          <span class="booking-section__title">Оформление путевки</span>
          <div class="booking-section__body">
            <trip-registration v-model="isPresent" />
          </div>
        </div>

        <div class="booking-section">
          <span class="booking-section__title">Покупатель</span>
          <div class="booking-section__body">
            <span>
              <b>{{ getPurchaserFullName }},</b> {{ getPurchaserPhone }}, {{ getPurchaserEmail }}
            </span>
          </div>
        </div>
      </div>

    </div>

    <div class="booking_footer">
      <div class="booking_footer-wrapper">
        <div class="booking_total">
          <span class="booking_total-label">Итого:</span>
          <span class="booking_total-value">{{dispTotal}}</span>
        </div>

        <div class="booking_actions">
          <a
            href="jqavascript:void(0)"
            class="ui-btn ui-btn--grey booking_action booking_action--back"
            @click.prevent="prevStep"
            v-if="bookingStep < 5"
          >
            Назад
          </a>

          <a
            href="jqavascript:void(0)"
            class="ui-btn booking_action"
            @click.prevent="nextStep"
            v-if="bookingStep < 5"
          >
            Далее
          </a>

          <a
            href="jqavascript:void(0)"
            class="ui-btn booking_action"
            @click.prevent="onClickBuyBtn()"
            v-if="bookingStep === 5"
          >
            Оплатить
          </a>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="isNoPlacesDialog"
      max-width="998"
      style="z-index:1002"
    >
      <ui-dialog
        title="Нет свободных мест на указанные даты"
        picture="img/misc/fail-pic.png"
        @close="isNoPlacesDialog = false"
      >
        <p class="booking-result_text">Вернитесь на шаг 1 и выберите другой вариант размещения.</p>
        <a href="/" class="booking-result_link">Вернуться на шаг 1</a>
      </ui-dialog>
    </v-dialog>

    <v-dialog
      v-model="paymentDialogFail"
      width="500"
      style="z-index:1002"
    >
      <ui-dialog
        title="Произошла ошибка"
        picture="img/misc/fail-pic.png"
        @close="paymentDialogFail = false"
      >
        <template v-slot:actions>
          <v-btn class="ui-btn ui-btn--grey ui-dialog_action" @click.prevent="paymentDialogFail = false">Закрыть</v-btn>
        </template>
      </ui-dialog>
    </v-dialog>

    <v-dialog
      v-model="validationErrorsDialog"
      max-width="500"
      style="z-index:1002"
    >
      <ui-dialog
        picture="img/misc/fail-pic.png"
        @close="validationErrorsDialog = false"
      >
        <ul class="booking_validation-errors-list">
          <li
            v-for="error, i in validationErrorsList"
            :key="i"
            class="booking_validation-errors-item"
          >
            {{error}}
          </li>
        </ul>

        <template v-slot:actions>
          <v-btn class="ui-btn ui-btn--grey ui-dialog_action" @click.prevent="validationErrorsDialog = false">Закрыть</v-btn>
        </template>
      </ui-dialog>
    </v-dialog>

    <v-dialog
      v-model="checkCheckoutTimeDialog"
      width="500"
      style="z-index:1002"
    >
      <ui-dialog
        @close="checkCheckoutTimeDialog = false"
        :noHeader="true"
      >
        <span class="text text--center">Не выбран расчетный час</span>

        <template v-slot:actions>
          <v-btn class="ui-btn ui-btn--grey ui-dialog_btn" @click.prevent="checkCheckoutTimeDialog = false">Закрыть</v-btn>
        </template>
      </ui-dialog>
    </v-dialog>

    <v-dialog
      v-model="purchaserShowDialog"
      max-width="700"
      style="z-index:1002"
    >
      <ui-dialog
        title="Покупатель"
        @close="purchaserShowDialog=false"
      >
        <div class="content-wrapper" style="width: 90%">
          <purchaser-form :purchaser="purchaser"
                          @validSubmit="onSubmitPurchaserForm"
                          ref="purchaserForm" />
        </div>
        <template v-slot:actions >
          <a
            href="javascript:void(0)"
            class="ui-btn ui-btn--grey booking_action booking_action--back"
            @click="purchaserShowDialog=false">
            Отменить
          </a>
          <a
            href="javascript:void(0)"
            class="ui-btn booking_action"
            @click="$refs.purchaserForm.submitForm()">
            Выбрать
          </a>
        </template>
      </ui-dialog>
    </v-dialog>

    <gift-dialog
      v-model="giftDialog"
      @sendSuccess="sendedAsGift = true"
    />
  </div>
</template>

<script>
import RoomLabel from '@/components/RoomLabel'
import GuestsList from '@/components/GuestsList'
import OptionsModule from '@/components/OptionsModule'
import TotalsModule from '@/components/TotalsModule'
import PaymentBonuses from '@/components/PaymentBonuses'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import CertificateForm from './CertificateForm.vue'
import GiftDialog from './GiftDialog.vue'
import UiDialog from './UI/UiDialog.vue'
import PresentSticker from '@/components/sticker/PresentSticker'
import PurchaserForm from '@/components/PurchaserForm'
import TripRegistration from '@/components/TripRegistration'
import Functions from "@/helpers/Functions";

export default {
  name: 'booking',

  components: {
    RoomLabel,
    GuestsList,
    OptionsModule,
    TotalsModule,
    PaymentBonuses,
    CertificateForm,
    GiftDialog,
    UiDialog,
    PresentSticker,
    PurchaserForm,
    TripRegistration,
  },

  data: () => ({
    validationErrorsDialog: false,
    validationErrorsList: [],
    paymentSuccessDialog: false,
    isNoPlacesDialog: false,

    orderId: null,
    paymentDialogFail: false,

    firstBillIsPayed: false,

    checkCheckoutTimeDialog: false,
    giftDialog: false,
    leaveAfterModalClose: true,
    purchaserShowDialog: false,
    sendedAsGift: false,

    offerAccepted: false,
    offerValidationError: false,

    purchaser: {},
  }),

  methods: {
    ...mapMutations({
      setCertificate: 'selection/setCertificate',
      setIsPresent: 'selection/setIsPresent',
      setBillType: 'selection/setBillType',
      setIsLoading: 'setIsLoading',
    }),

    ...mapActions({
      changeStep: 'changeStep',
      checkStepComplete: 'checkStepComplete',
      storeSaveBooking: 'selection/saveBooking',
      resetBooking: 'resetBooking',
      selectPurchaser: 'guestsModule/selectPurchaser',
      storeSetIsPrepayment: 'selection/setIsPrepayment',
    }),

    showPurchaserDialog() {
      this.purchaserShowDialog = true;
    },

    closePurchaserDialog() {
      this.purchaserShowDialog = false;
    },

    /**
     * Согласие с договором публичной оферты (шаг «Подтверждение»).
     * Только для сайта «Ключи»: на остальных тенантах бронируем без чекбокса.
     */
    checkOfferConsent() {
      if(!this.isKluchi) return true
      if(this.offerAccepted) return true

      this.offerValidationError = true
      this.validationErrorsList = [`Подтвердите ознакомление с договором публичной оферты`]
      this.validationErrorsDialog = true
      return false
    },

    async onSubmitPurchaserForm(event) {
      if(!this.checkOfferConsent()) return

      this.closePurchaserDialog();
      this.selectPurchaser({
        purchaser: this.purchaser,
      });

      let saveResult = await this.storeSaveBooking()
      this.onPrepayUpdate()
      // console.log(saveResult)
      if(typeof ym !== 'undefined') {
        ym(process.env.VUE_APP_METRIKA_KEY,'reachGoal','agree')
      }
      this.changeStep(this.bookingStep + 1)
    },

    async nextStep() {
      let status = `OK`
      if(this.bookingStep === 2) {
        let isValid = await this.validateStep2()
        if(!isValid) return
        if(typeof ym !== 'undefined') {
          ym(process.env.VUE_APP_METRIKA_KEY,'reachGoal','guest')
        }
      }

      if(this.bookingStep === 3) {
        let isValid = this.validateStep3()
        // console.log(isValid)
        if(!isValid) return
      }

      if(this.bookingStep === 4) {
        let isValid = this.validateStep4()
        if(!isValid) return false;

        this.showPurchaserDialog(); return;
      }

      if(status === `OK`) {
        this.changeStep(this.bookingStep + 1)
      }
    },

    prevStep() {
      let curStep = this.bookingStep
      let prevStep = curStep - 1

      this.changeStep(prevStep)
    },

    async validateStep2() {
      this.validationErrorsList = []

      const isValid = await this.$refs.guestsForm.validate()
      this.getGuestsFields([
        'id',
        'firstName',
        'secondName',
        'thirdName',
        'isNoThirdName',
        'guestType',
        'birthday',
        'gender',
        'email',
        'phone',
      ]).forEach((guest, i) => {
        let isComplited = true
        for(let field in guest) {
          if(field === 'thirdName' && guest['isNoThirdName']) {
            continue
          }

          // исключение номера и мейла, если гость ребенок
          if(guest.guestType !== '0' && (
            field === 'phone'
            || field === 'email'
          )) {
            continue
          }

          if(
            guest[field] === null
            || guest[field] === undefined
            || typeof(guest[field]) === 'string' && guest[field].trim() === ''
          ) {
            isComplited = false
          }
        }

        if(!isComplited) {
          this.validationErrorsList.push(`Гость ${i + 1}: заполнены не все данные`)
        }
      })

      const guestTypeList = this.getGuestsList.map((guest) => +guest.guestType);
      const countAdults = guestTypeList.filter(value => value === 0).length;
      const countChild = guestTypeList.filter(value => value === 1).length;
      const countBabies = guestTypeList.filter(value => value === 2).length;
      const isOneAdultWithBabies = countAdults === 1 && countChild === 0 && countBabies > 0;

      if(
        +this.selectedVariant.capacity === 2 && isOneAdultWithBabies
      ) {
        this.validationErrorsList.push(`Заезд в двухместный номер одного взрослого с детьми до 3-х лет невозможен`)
      }

      if(this.validationErrorsList.length > 0) {
        this.validationErrorsDialog = true
        return false
      }

      if (!isValid) {
        this.validationErrorsList.push('Проверьте правильность заполнения полей');
        this.validationErrorsDialog = true
        return false;
      }

      return true
    },

    validateStep3() {
      let res = true
      let parkingForm = this.$refs.optionsModule.$refs.parkingForm
      let transferForm = this.$refs.optionsModule.$refs.transferForm
      // console.log(parkingForm)
      // console.log(parkingForm.validate())
      if(
        (this.$refs.optionsModule.$refs.parkingForm && !this.$refs.optionsModule.$refs.parkingForm.validate())
        || (this.$refs.optionsModule.$refs.transferForm && !this.$refs.optionsModule.$refs.transferForm.validate())
      ) {
        res = false
      }

      if((this.$refs.optionsModule.$refs.checkout && !this.$refs.optionsModule.$refs.checkout.validate())) {
        res = false
        this.checkCheckoutTimeDialog = true
      }
      return res
    },

    validateStep4() {
      this.validationErrorsList = []
      let guests = this.getGuestsFields([
        'id',
      ])

      if(!this.checkOfferConsent()) {
        return false
      }

      if(this.validationErrorsList.length > 0) {
        this.validationErrorsDialog = true
        return false
      }

      return true
    },

    onClickBuyBtn() {
      if(!this.checkOfferConsent()) return

      this.onPrepayUpdate()
        .then(() => {
          this.selectPaymentMethod(this.paymentMethod)
          if(typeof ym !== 'undefined') {
            ym(process.env.VUE_APP_METRIKA_KEY,'reachGoal','buy')
          }
        })
    },

    onPrepayUpdate() {
      return new Promise((resolve, reject) => {
        const payload = {
          bookingType: this.isPresent ? "present" : "buy",
        };
        this.$http
          .post(`/deal/${this.savedBookingInfo.dealId}/prepayUpdate/`, payload)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          });
      });
    },

    selectPaymentMethod(method) {
      if (method === `credit`) {
        this.ukassa(true)
      } else if (method === `ukassa`) {
        this.ukassa()
      }
    },

    async ukassa(isCredit = false) {
      this.setIsLoading(true)

      let mainOrderRedirectUrl = window.settings.redirectUrl + `?deal-id=${this.savedBookingInfo.dealId}`

      // если у заказа есть доп. услуги - запрос на формирование доп услуг
      if (this.orderHaveExtraServices) {
        this.setBillType('extra-servises')
        const extraServicesPayload = this.getUkassaPayload()

        if (window.settings.bookingAllowedPayment) {
          extraServicesPayload.paymentMethodData = {
            type: window.settings.bookingAllowedPayment,
          }
        }
        extraServicesPayload.returnUrl = mainOrderRedirectUrl

        try {
          const response = await this.$http.post(`/payment/create/`, extraServicesPayload)
        }
        catch(e) {
          console.error(e)
        }
      }

      // запрос на главные услуги
      this.setBillType('main')
      const mainPayload = this.getUkassaPayload()
      if (window.settings.bookingAllowedPayment || isCredit) {
        mainPayload.paymentMethodData = {
          type: isCredit ? 'sber_loan' : window.settings.bookingAllowedPayment,
        }
      }
      mainPayload.returnUrl = mainOrderRedirectUrl

      try {
        const resp = await this.$http.post(`/payment/create/`, mainPayload)
        const url = resp?.data?.data?.confirmationUrl
        if (url) {
          window.location.href = url
        } else {
          console.error(resp)
        }
      }
      catch (e) {
        console.error(e)
      }
      this.setIsLoading(false)
    },

    getUkassaPayload() {
      const payload = {
        order: {
          sum: +this.getPrices.main,
          description: this.savedBookingInfo.sbp.orderDescription,
          orderNumber: this.savedBookingInfo.sbp.orderNumber,
        },
        customer: {
          email: this.getPurchaser.email,
          phone: Functions.unformatPhone(this.getPurchaser.phone),
          fullName: this.getPurchaser.fullName,
        },
      }

      if(this.isPrepayment) {
        payload.order = {
          sum: this.getPrices.prepayment,
          description: this.savedBookingInfo.sbp.orderPrepaymentDescription,
          orderNumber: this.savedBookingInfo.sbp.orderPrepaymentNumber,
        }
      }

      if(this.billType === 'extra-servises') {
        payload.order = {
          sum: this.getPrices.extra,
          description: this.savedBookingInfo.sbp.extraServices.orderDescription,
          orderNumber: this.savedBookingInfo.sbp.extraServices.orderNumber,
        }
      }

      return payload
    },

    onGiftSended() {
      this.leaveAfterModalClose = false
    },

    leaveBooking() {
      document.location.href = '/'
    },
  },

  computed: {
    ...mapState({
      bookingId: state => state.bookingId,
      bookingStep: state => state.bookingStep,
      bookingDateStart: state => state.selection.dateIn,
      bookingDateEnd: state => state.selection.dateOut,
      isGuestsComplete: state => state.isGuestsComplete,
      categoryIcons: state => state.dictionaries.categoryIcons,
      savedBookingInfo: state => state.selection.savedBookingInfo,
      isPrepayment: state => state.selection.isPrepayment,
      paymentMethod: state => state.selection.paymentMethod,
      loyaltyPrograms: state => state.loyalty.programs,
      certificates: state => state.selection.certificates,
      billType: state => state.selection.billType,
    }),

    ...mapGetters({
      totalPrice: 'getTotalPrice',
      getFilteredGuestsFields: 'guestsModule/getFilteredGuestsFields',
      getComplitedGuests: 'guestsModule/getComplitedGuests',
      getGuestsFields: 'guestsModule/getGuestsFields',
      getGuestsList: 'guestsModule/getGuestsList',
      selectedVariant: 'selection/getSelectedCategory',
      getUdsData: 'loyalty/getUdsData',
      getPurchaser: 'guestsModule/getPurchaser',
      getIsPresent: `selection/getIsPresent`,
      getPrices: `selection/getPrices`,
      certificatesSum: `selection/getCertificatesSum`
    }),

    orderHaveExtraServices() {
      return !this.isPrepayment && +this.savedBookingInfo?.extraServicePrice > 0
    },

    isKluchi() {
      return process.env.VUE_APP_SITE === 'kluchi'
    },

    isPresent: {
      get() {
        return this.getIsPresent;
      },
      set(value) {
        this.setIsPresent(value);

        // Если это подарок - предоплата невозможна
        if (value) {
          this.storeSetIsPrepayment(false);
        }
      },
    },

    isPurchaserNotGuest() {
      return this.getPurchaser.isNotGuest;
    },

    getPurchaserFullName() {
      let purchaser = this.getPurchaser,
        secondName = purchaser.secondName,
        name = purchaser.firstName,
        thirdName = purchaser.thirdName ?? "";
      return `${secondName} ${name} ${thirdName}`;
    },

    getPurchaserPhone() {
      return this.getPurchaser.phone;
    },

    getPurchaserEmail() {
      return this.getPurchaser.email;
    },

    udsLoyaltyProgram() {
      return this.loyaltyPrograms.find(obj => obj.id === `uds`)
    },

    dispDates() {
      let start = this.bookingDateStart.split('-')
      let end = this.bookingDateEnd.split('-')

      return `${start[2]}.${start[1]}.${start[0]} - ${end[2]}.${end[1]}.${end[0]}`
    },

    dispTotal() {
      let sum = 0
      if(this.bookingStep < 5) {
        sum = this.totalPrice
      } else {
        if(this.isPrepayment) {
          sum = this.savedBookingInfo.prepaymentPrice
        } else {
          if(this.paymentMethod === `credit`) {
            sum = this.savedBookingInfo.ticketPrice
          } else if(this.paymentMethod === `installment`) {
            sum = +this.savedBookingInfo.ticketPrice / 100 * 95
          } else {
            const { main: mainPrice } = this.getPrices
            const extraPrice = this.savedBookingInfo.extraServicePrice
            sum = this.firstBillIsPayed ? extraPrice : (mainPrice + extraPrice)
          }
        }
      }

      return `${String(Math.round(sum)).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')} р`
    },
  },

  watch: {
    offerAccepted(value) {
      if(value) this.offerValidationError = false
    },

    giftDialog(v) {
      if (!v) {
        if(this.sendedAsGift) {
          this.leaveBooking()
        } else {
          this.leaveAfterModalClose = true
        }
      }
    },

    isNoPlacesDialog(newVal, oldVal) {
      if(oldVal === true) {
        document.location.href = '/'
      }
    },
  },
}
</script>

<style lang="sass">
.btn-disable
  pointer-events: none
  opacity: 0.7

.payment__method-wrap
  margin-top: 10px
  padding-top: 20px
  border-top: 1px solid #8A8A8A

.booking
  width: 100%
  // max-width: px-em(1100)
  min-height: 100%
  margin: 0 auto
  // padding-bottom: px-em(170)
  display: flex
  flex-direction: column

.booking_header
  width: 100%
  display: flex
  align-items: center
  margin-bottom: px-em(30)
  column-gap: 10px

.booking_dates-label
  font-weight: 900
  color: #248983
  padding: px-em(10) px-em(20)
  background-color: #FFFAE4
  border-radius: px-em(20)

.booking_room-label
  margin-left: auto

.booking_body
  // margin-bottom: auto


.booking_certificate-section
  width: 100%
  margin-top: px-em(20)
  padding-top: px-em(50)
  border-top: 1px solid #8A8A8A

.booking_certificate-section-title
  font-size: px-em(18)
  font-weight: 500
  display: block
  margin-bottom: px-em(40, 18)

.booking-section
  width: 100%
  margin-top: px-em(20)
  padding-top: px-em(50)
  border-top: 1px solid #8A8A8A

.booking-section__title
  font-size: px-em(18)
  font-weight: 500
  display: block
  margin-bottom: px-em(40, 18)

.booking-section--offer-consent
  margin-top: px-em(20)
  padding-top: px-em(25)

.booking_offer-consent-checkbox
  &.v-input--selection-controls
    margin-top: 0

.booking_offer-consent-link
  color: $prime-color
  text-decoration: underline

  &:hover
    text-decoration: none

// .booking_certificate-section-form
//   max-width: px-em(900)


.booking_footer
  width: calc(100% + px-em(40))
  position: sticky
  bottom: 0
  left: 0
  margin-right: px-em(-20)
  margin-left: px-em(-20)
  padding-left: px-em(20)
  padding-right: px-em(20)
  background-color: #fff
  z-index: 8
  border-top: 1px solid #8A8A8A
  margin-top: px-em(40)

.booking_footer-wrapper
  width: 100%
  // max-width: px-em(1100)
  margin: 0 auto
  background-color: inherit
  display: flex
  align-items: center
  justify-content: space-between
  padding-top: px-em(30)
  padding-bottom: px-em(30)

.booking_total
  display: flex
  align-items: baseline
  color: #696D74

.booking_total-label
  font-weight: 300
  margin-right: px-em(22)

.booking_total-value
  font-size: 2.1875em
  font-weight: 700
  color: #1A4745

.booking_actions
  display: flex

.booking_action
  + .booking_action
    margin-left: px-em(20)

.booking_validation-errors-list
  padding: 0
  margin: 0
  list-style: none
  color: #C01717

.v-application .booking_validation-errors-list
  padding: 0
  margin: 0

.booking_validation-errors-item
  + .booking_validation-errors-item
    margin-top: px-em(10)



.booking-result
  display: flex
  flex-direction: column
  align-items: center
  color: #616161

.booking-result_icon
  width: px-em(60)
  height: px-em(60)
  border-radius: 50%
  display: flex
  align-items: center
  justify-content: center
  margin-bottom: px-em(20)

  color: #fff
  // font-size: px-em(33)
  line-height: 1

  &--green
    background-color: #32BEA6

  &--red
    background-color: #ED2626

  .ui-icon
    font-size: px-em(33)

.booking-result_title
  display: block
  text-align: center
  margin-bottom: px-em(23, 35)
  font-size: px-em(35)
  line-height: 1.25714
  font-weight: 700

.v-application .booking-result_text
  margin: 0 0 px-em(15)

.booking-result_text
  margin: 0 0 px-em(15)
  padding: 0
  text-align: center

.booking-result_link
  margin: 0 auto


.payment-method
  padding: px-em(40) px-em(45) px-em(60)
  color: #696D74

.payment-method_inner
  display: flex
  flex-direction: column
  align-items: center

.payment-method_icon-wrapper
  max-width: px-em(93)
  margin-bottom: px-em(20)
  display: flex
  align-items: center
  justify-content: center

.payment-method_icon
  max-width: 100%
  flex-shrink: 0

.payment-method_title
  font-size: px-em(35)
  font-weight: 700
  margin-bottom: px-em(25, 35)
  text-align: center

.payment-method_subtitle
  margin-bottom: px-em(25)

.payment-method_action_wrapper
  display: flex
  justify-content: center
  margin-bottom: 25px

.payment-method_actions
  width: 100%
  display: flex
  justify-content: center
  flex-direction: column

.payment-method_action
  flex: 1 1 50%
  max-width: px-em(230)
  display: flex
  align-items: center
  justify-content: center
  background-color: #ECFAFB
  border: px-em(2) solid #248983
  border-radius: px-em(50)
  position: relative
  padding: px-em(16)
  margin-bottom: px-em(20)
  min-height: px-em(105)

  &--sbp
    .payment-method_action-title
      font-size: 1.5em

  + .payment-method_action
    margin-left: px-em(20)

.payment-method_action-icon-wrapper
  flex-shrink: 0
  width: px-em(50)
  margin-right: px-em(20)
  line-height: 0
  display: flex
  align-items: center
  justify-content: center

.payment-method_icon
  max-width: 100%
  flex-shrink: 0

.payment-method_action-text
  display: flex
  flex-direction: column
  align-items: center

.payment-method_action-title
  color: #1A4745
  font-weight: 500

.payment-method_action-subtitle
  font-size: px-em(12)

.payment-method_action-overlay
  position: absolute
  top: 0
  bottom: 0
  right: 0
  left: 0
  display: block
  text-decoration: none
  z-index: 1

.payment-method_action-footnote-in
  position: absolute
  bottom: px-em(8)
  font-size: px-em(12)

.payment-method_action-footnote-out
  position: absolute
  bottom: 0
  transform: translateY(calc(100% + px-em(10)))
  font-size: px-em(12)

.payment-method_footnote
  font-size: px-em(12)
  margin-top: px-em(20,12)
  align-self: flex-start

.payment-method_footnote-logo
  width: 1.4em
  vertical-align: baseline

.sbp-dialog_content
  display: flex
  flex-direction: column
  align-items: center

.sbp-dialog_text
  display: block
  text-align: center
  margin-top: px-em(30)

.sbp-dialog_actions
  display: flex
  flex-direction: column
  align-items: center

.sbp-dialog_action
  + .sbp-dialog_action
    margin-top: 20px
    margin-left: 0


@media screen and (max-width: $mobile-breakpoint)
  .booking_header
    flex-direction: column
    row-gap: px-em(10, 12)

  .booking_dates-label
    font-size: 1em
    padding: px-em(13, 12) px-em(38, 12)
    border-radius: px-em(20, 12)

  .booking_footer
    position: static

  .booking_footer-wrapper
    flex-direction: column

  .booking_total
    width: 100%
    justify-content: space-between
    margin-bottom: px-em(20, 12)

  .booking_total-value
    font-size: px-em(16, 12)

  .booking_actions
    width: 100%
    flex-direction: column

  .booking_action
    width: 100%

    + .booking_action
      margin-left: 0


    &--back
      order: 1
      margin-top: px-em(10, 12)

  .booking_room-label
    margin-left: 0
</style>
